import styled from 'styled-components';

import StyledLink from '../../../../components/StyledLink';

const StyledButtonLink = styled(StyledLink)``;

export default StyledButtonLink;
